module.exports = __webpack_public_path__ + "img/mbg.d25a8668.png";